itsoftApp.createModule("videoPopup", ["popups"], function () {
    const module = this;
    const videoEls = document.querySelectorAll("video");

    if (videoEls.length > 0) {
        videoEls.forEach(function (videoEl) {
            videoEl.setAttribute("controlslist", "nodownload");
        });
    }
    
    const VideoPopup = function (triggerButton, popup) {
        this.triggerButton = triggerButton;
        this.popup = popup;
        this.video = popup.querySelector("video");

        this.init();
    }

    VideoPopup.prototype.init = function () {
        const VIDEO_POPUP = this;
        const popup = VIDEO_POPUP.popup;
        const video = VIDEO_POPUP.video;

        this.onPopupOpenListener = this.onPopupOpen.bind(VIDEO_POPUP);
        this.onPopupCloseListener = this.onPopupClose.bind(VIDEO_POPUP);
        // this.onVideoPlayListener = this.onVideoPlay.bind(VIDEO_POPUP);

        popup && popup.addEventListener("popups:open", this.onPopupOpenListener);
        popup && popup.addEventListener("popups:close", this.onPopupCloseListener);

        // popup.dispatchEvent(window.openEvent);
        // video.addEventListener("click", onVideoPlayListener);
    }

    VideoPopup.prototype.onPopupOpen = function (evt) {
        const VIDEO_POPUP = this;
        VIDEO_POPUP.video.play();
        VIDEO_POPUP.video.classList.add("js-active");

    }

    VideoPopup.prototype.onPopupClose = function (evt) {
        const VIDEO_POPUP = this;
        VIDEO_POPUP.video.pause();
        VIDEO_POPUP.video.classList.remove("js-active");
    }

    const videoPopupInit = function (triggerButton) {
        const popup = document.querySelector("#" + triggerButton.getAttribute("data-popup-id"));

        new VideoPopup(triggerButton, popup);
    }

    module.init = videoPopupInit;
});